<template>
  <div>
    <div class="row">
      <div class="toolbar m-2">
        <div class="btn-group">
          <button @click="createNode" class="btn-sm m-2 form-control btn-success"><font-awesome-icon icon="plus"/></button>
          <button @click="openNode"   class="btn-sm m-2 form-control btn-primary"><font-awesome-icon icon="edit"/></button>
          <button @click="deleteNode" class="btn-sm m-2 form-control btn-danger"><font-awesome-icon icon="trash"/></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="treeview w-100 ml-3 mr-3">
        <ul class="list-group">
          <li class="list-group-item" v-bind:class="{active : selected.id == 0}"><strong style="cursor: pointer;" @click="selectRoot">Hauptkategorie</strong></li>
        </ul>
      </div>
    </div>
    <div class="row">
      <CTreeItem ref="treeview" @selectnode="recvSelectedNode" :treeid="treeid" :treestate="selected" parent="0" depth="0"/>
    </div>
    <b-modal id="nodeEditor" title="Kategorie" @ok="saveCurrentNode">
      <div class="m-2">
        <div class="row">
          <div class="form-group">
            <label>Eltern-Kategorie:</label>
            <select v-model="editNode.parent" class="form-control">
              <option v-if="selected" :value="selected.id">{{ selected.name }}</option>
              <option value="0">Wurzelkategorie</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Name:</label>
            <input v-model="editNode.name" type="text" class="form-control"/>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Kurzbeschreibung:</label>
            <textarea class="form-control" v-model="editNode.description"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Sortierposition:</label>
            <input v-model="editNode.sort" type="text" class="form-control"/>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import CTreeItem from '@/components/tree/CTreeItem.vue'

export default {
  name: 'CTreeView',
  props: ['treeid'],
  components: {
    CTreeItem
  },
  data() {
    return {
      selected: { id: 0, parent: 0, name: "", sort: 0 },
      editNode: {},
    }
  },
  methods: {
    createNode: function() {
      this.editNode = { id: 0, parent: 0, name: "", sort: 0, treeid: this.treeid };
      if (this.selected) this.editNode.parent = this.selected.id;
      this.$bvModal.show('nodeEditor');
    },
    openNode: function() {
      if (!this.selected || this.selected.id == 0) {
        this.$bvToast.toast('Bitte wählen Sie zuerst eine Kategorie aus.',{title: 'Kategorien', variant: 'warning'});
        return;
      }
      this.editNode = this.selected;
      this.$bvModal.show('nodeEditor');
    },
    deleteNode: function() {
      if (!this.selected || this.selected.id == 0) {
        this.$bvToast.toast('Bitte wählen Sie zuerst eine Kategorie aus.',{title: 'Kategorien', variant: 'warning'});
        return;
      }
      var self = this;
      if (confirm('Möchten Sie die Kategorie: ' + this.selected.name + ' wirklich löschen?')) {
        config.delete(this,config.baseUrl + 'rest/ctree/nodes/' + encodeURIComponent(this.treeid) + '/' + encodeURIComponent(this.selected.id),'Kategorie löschen',function() {
          self.$bvToast.toast('Kategorie gelöscht.',{title: 'Kategtorien', variant: 'success'});
          self.selected = false;
          self.$refs.treeview.reload();
        });
      }
    },
    activateNode(node) {
      console.log('show node: ');
      console.log(node);
      if (node && node.id !== 0) {
        var self = this;
        config.get(this,config.baseUrl + 'rest/ctree/nodes/' + encodeURIComponent(this.treeid) + '/' + encodeURIComponent(node.id) + '/path','Kategorie Pfad',function(data) {
          console.log(data);
          if (data.length && data[0] == 0) {
            console.log('got path');
            data.shift();
            self.selected = { path: data.id, id: -1};
          }
        });
      }
    },
    selectRoot: function() {
      this.recvSelectedNode({id:0, name:"Root",treeid: this.treeid, sort: 0});
    },
    recvSelectedNode: function(node) {
      this.selected = node;
      this.$emit('selectnode',node);
    },
    saveCurrentNode: function() {
      var self = this;
      // check new or update
      if (this.editNode.id == 0) {
          config.put(this,config.baseUrl + 'rest/ctree/nodes','Kategorie anlegen.',JSON.stringify(this.editNode),function() {
            self.$bvToast.toast('Kategorie gespeichert',{title: 'Kategorien',variant: 'success'})
            self.$refs.treeview.reload();
          });
      } else {
        config.post(this,config.baseUrl + 'rest/ctree/nodes','Kategorie anlegen.',JSON.stringify(this.editNode),function() {
          self.$bvToast.toast('Kategorie gespeichert',{title: 'Kategorien',variant: 'success'})
          self.$refs.treeview.reload();
        });
      }
    }
  }
}
</script>
